import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/provider.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/footer.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/page/root/sections/header.jsx")